import React, { useState, useEffect } from "react";
import * as url from "../../../../utils/url";
import axios from "../../../../axios";
import { Button, Card } from "reactstrap";
import TextSentimentComponentOverall from "./TextSentimentComponentOverall";
import { BiRecycle } from "react-icons/bi";
import parse from "react-html-parser";
import { BsStar, BsStars } from "react-icons/bs";

export default function MessagingTriviaResultsSummary({ trivia,showRecommendations }) {
  const [summaryData, setSummaryData] = useState(null);
  

  // useEffect(() => {
  //   axios
  //     .get(url.fetchMessagingTrivvyAnalyticsResults(trivia._id))
  //     .then(({ data }) => {
  //       setSummaryData(data.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);



    if (trivia && trivia.isOneWay === true) {
      return (
        <div className="text-center mt-5">
          <p>Results are not available for 1-way messages.</p>
        </div>
      );
    }

    return (
      <div>
        <Card className="p-3">
         <div> <h5>
          Message Title:{" "} </h5>
          <div> {trivia.name
              ? trivia.name
              : `No title`}
              {/* `${trivia.messagingSubject.slice(0, 10)}...` */}</div>
          </div>
          <div className="mt-4">
            <h5>Message Content:</h5>
            {trivia.messagingSubject}</div>
        </Card>
  
        {trivia && (
          <Card className="p-3 ">
            <div className="d-flex justify-content-between px-5">
              <div className="text-center display-trivia-res-stat">
                <h5>Total submissions</h5>
                <div className="mt-3">
                  <div
                    className={`count_text ${
                      trivia && trivia.totalSubmissions > 0
                        ? "text-info"
                        : ""
                    } `}
                  >
                    {trivia.totalSubmissions || 0}
                  </div>
                </div>
              </div>
  
              <div>
                {trivia && trivia.totalSentimentCounts ?
                  <div className="tiv2_sentiment_wrapper tiv2_sentiment_wrapper--inline">
                    <TextSentimentComponentOverall
                      data={trivia.totalSentimentCounts}
                      totalSentimentCounts={trivia.totalSentimentCounts}
                      titleAlign="center"
                      totalSumOfNumResponses={trivia.totalSubmissions}
                      currentTrivvy={trivia}
                    />
                  </div> : ""
                }
              </div>
            </div>    
          </Card>
        )}
      </div>
    );
  

  
}
